// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__Lcs5E","blocktext":"Banner_blocktext__1sKOq","illus":"Banner_illus__aLpMN","title":"Banner_title__3r7KR","desc":"Banner_desc__2Wwr7"};